import { useState } from 'react';
import { AdcashGuruAdforusMetrics } from '../../../../types/adcash.types';
import GuruPage from '../../../../components/adcash/guru/GuruPage';
import AdcashGuruDashboard from '../../../../components/adcash/guru/AdcashGuruDashboard';
import AdcashGuruAdforusMetricsTable from '../../../../components/adcash/guru/table/AdcashGuruAdforusMetricsTable';

const INITIAL: AdcashGuruAdforusMetrics = {
  prevTotalRevenue: 0, prevTotalImp: 0, prevTotalClk: 0,
  totalRevenue: 0, totalImp: 0, totalClk: 0,
  dailyStats: [],
};

export default function GuruAdforus() {
  const [exchangeRate, setExchangeRate] = useState<number>(1230);
  return (
    <GuruPage
      apiSlug="adforus"
      initialMetrics={INITIAL}
      renderDashboard={(data) => <AdcashGuruDashboard dailyStats={data.dailyStats} exchangeRate={exchangeRate} />}
      renderTable={(data) => <AdcashGuruAdforusMetricsTable data={data} exchangeRate={exchangeRate} onExchangeRateChange={setExchangeRate} />}
      tableWidth="900px"
    />
  );
}
